import { ContextForm } from './ContextForm';

export const metadata = {
  title: 'Mood Step 3 | Patchooli',
  description: 'Mood Log Entry | Step 3 | Patchooli',
};

export const MoodLogEntryStep3Page = () => {
  return <ContextForm />;
};
